export default __webpack_public_path__ + "static/media/phone_bg.6a216881.png";